import React from "react"
import { Select, SelectProps } from "@chakra-ui/react"
import Icon from "@components/Icon/Icon"

const Dropdown = React.forwardRef((props: SelectProps, ref) => (
  <Select ref={ref} w="fit-content" icon={<Icon name="chevronDown" />} iconSize="19px" {...props} />
))

export default Dropdown
